<template>
  <div>
    <v-dialog
      v-model="modal"
      width="550"
      hide-overlay
      transition="fab-transition"
    >
      <template> </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">
            <h3>Seleccione el usuario Autorizador</h3></span
          >
        </v-card-title>
        <v-card-text>
          <v-row class="pl-3 pr-3">
            <v-col cols="11" class="pb-4" v-if="usuario_cortesia == null">
              <v-autocomplete
                :value="usuario_cortesia_id"
                :items="users_cortesia"
                label="Usuario"
                hide-details
                outlined
                :item-text="customText"
                item-value="id"
                clearable
                @change="handleSelectClient"
                :filter="customFilter"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                    <!-- <v-list-item-subtitle>
                      RUC: {{ data.item.ruc }}
                    </v-list-item-subtitle> -->
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <!-- <v-col cols="1" class="pl-0" v-if="usuario_cortesia == null">
              <v-icon
                color="success"
                class="mt-2"
                @click="handleViewCreateCompany"
              >
                fas fa-plus-circle
              </v-icon>
            </v-col> -->
          </v-row>
          <v-row class="pl-3 pr-3" v-if="usuario_cortesia">
            <v-col cols="12" class="pt-0 pb-0">
              <v-list two-line class="pt-0 pb-0">
                <v-list-item class="pl-1 pr-1">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon color="green" class="mr-2" size="18">
                        fas fa-user-tag
                      </v-icon>
                      <span
                        class="text-uppercase font-weight-bold cart-label-customer"
                        >{{ usuario_cortesia.name }}</span
                      >
                    </v-list-item-title>
                    <!-- <v-list-item-subtitle>
                      <span class="ml-8">
                        RUC: {{ usuario_cortesia.ruc }}
                      </span>
                    </v-list-item-subtitle> -->
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="handleClearClient" color="red">
                      <v-icon>far fa-times-circle</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-container class="pt-0 pb-0">
            <v-row>
              <v-col cols="6">
                <v-btn dark color="red" block @click="closeModal">
                  Cancelar
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn dark color="green" block @click="saveModal">
                  Aceptar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ArrayTools from "../../helpers/ArrayTools";
import { mapState, mapActions } from "vuex";
export default {
  name: "Cortesia",
  components: {},
  props: { handleChangeCortesia: Function },
  mounted() {
    this.getAllListUsers();
  },
  data() {
    return {
      name: null,
      modal: false,
    };
  },
  computed: {
    ...mapState("users", ["users_cortesia"]),
    ...mapState("sales", ["usuario_cortesia", "usuario_cortesia_id"]),
  },
  methods: {
    ...mapActions("sales", [
      "select_document_active",
      "select_usuario_cortesia",
    ]),
    ...mapActions("users", ["getAllListUsers"]),
    customText(item) {
      let text = item.name;

      return text;
    },
    customFilter(item, queryText, itemText) {
      let textName = "";
      if (item.name) {
        if (item.fullname) {
          textName = item.fullname.toLowerCase();
        } else {
          textName = item.name.toLowerCase();
        }
      }
      let textDocument = "";
      if (item.document) {
        textDocument = item.document.toLowerCase();
      }
      let searchText = queryText.toLowerCase();

      return (
        textName.indexOf(searchText) > -1 ||
        textDocument.indexOf(searchText) > -1
      );
    },
    showForm(params) {
      // let {name}=params
      // this.name=name
      this.modal = !this.modal;
      // console.log(this.name)
    },

    closeModal() {
      this.modal = !this.modal;
      this.select_document_active("TICKET");
      this.handleClearClient();
    },
    saveModal() {
      if (this.usuario_cortesia != null) {
        this.handleChangeCortesia(this.usuario_cortesia);
        this.modal = !this.modal;
      }
    },
    handleSelectClient(value) {
      if (value == null || value == undefined) {
        this.select_usuario_cortesia(null);
      } else {
        let selected_user_cortesia = ArrayTools.getElementById(
          this.users_cortesia,
          value
        );
        this.select_usuario_cortesia(selected_user_cortesia);
      }
    },
    handleClearClient() {
      this.select_usuario_cortesia(null);
    },
  },
};
</script>
